import { useState } from "react";
import api from "../../utils/api";
import UploadImage from "../UploadImage";

export default function EditProduct({ product, onSuccess }) {
  const [newProductCode, setNewProductCode] = useState(product.productCode);
  const [newName, setNewName] = useState(product.name);
  const [newDescription, setNewDescription] = useState(product.description);
  const [newStatus, setNewStatus] = useState(product.status);
  const [newImageFile, setNewImageFile] = useState(null);
  const [newImagePreview, setNewImagePreview] = useState(
    product.imageUrl
      ? `${process.env.REACT_APP_API_URL}/${product.imageUrl}`
      : null,
  );

  const handleImageSelect = (file) => {
    setNewImageFile(file);
    setNewImagePreview(URL.createObjectURL(file));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("productCode", newProductCode);
    formData.append("name", newName);
    formData.append("description", newDescription);
    formData.append("status", newStatus);

    if (newImageFile) {
      formData.append("image", newImageFile);
    }

    try {
      await api.patch(`/products/${product._id}`, formData, {
        withCredentials: true,
        headers: { "Content-Type": "multipart/form-data" },
      });

      alert("Product updated successfully!");
      if (onSuccess) onSuccess();
    } catch (error) {
      console.error(error.response?.data || error.message);
      alert(error.response?.data?.message || error.message);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="max-w-md mx-auto bg-white rounded-2xl shadow-sm border border-gray-200 p-6"
    >
      <h2 className="text-xl font-semibold text-gray-800 mb-6">
        Update Product
      </h2>

      <div className="mb-5">
        <label className="block text-sm font-medium text-gray-600 mb-1">
          Product Code
        </label>
        <input
          type="text"
          placeholder="Product Code"
          value={newProductCode}
          onChange={(e) => setNewProductCode(e.target.value)}
          className="w-full rounded-lg border border-gray-300 px-3 py-2 text-gray-800
                 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        />
      </div>

      <div className="mb-5">
        <label className="block text-sm font-medium text-gray-600 mb-1">
          Name
        </label>
        <input
          type="text"
          placeholder="Product Name"
          value={newName}
          onChange={(e) => setNewName(e.target.value)}
          className="w-full rounded-lg border border-gray-300 px-3 py-2 text-gray-800
                 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        />
      </div>

      <div className="mb-5">
        <label className="block text-sm font-medium text-gray-600 mb-1">
          Description
        </label>
        <input
          type="text"
          placeholder="Description"
          value={newDescription}
          onChange={(e) => setNewDescription(e.target.value)}
          className="w-full rounded-lg border border-gray-300 px-3 py-2 text-gray-800
                 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        />
      </div>

      <div className="mb-6">
        <label className="block text-sm font-medium text-gray-600 mb-1">
          Status
        </label>
        <select
          value={newStatus}
          onChange={(e) => setNewStatus(e.target.value)}
          className="w-full rounded-lg border border-gray-300 px-3 py-2 text-gray-800 bg-white
                 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        >
          <option value="" disabled selected>
            Select Status
          </option>
          <option value="Active">Active</option>
          <option value="Expired">Expired</option>
        </select>
      </div>
      <div className="mb-6">
        <UploadImage
          onFileSelect={handleImageSelect}
          preview={newImagePreview}
        />
      </div>

      <button
        type="submit"
        className="w-full rounded-lg bg-blue-600 py-2.5 text-white font-medium
               hover:bg-blue-700 transition focus:outline-none focus:ring-2
               focus:ring-blue-500 focus:ring-offset-2"
      >
        Update Product
      </button>
    </form>
  );
}
